import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons'
import { memo } from 'react'

import { COLOR_ERROR } from '../../../constants/theme'
import Popup from '../../shared/popup/Popup'

const SomethingWentWrong = ({ onSubmit, t }) => (
  <Popup
    title={t('common.oops')}
    description={t('error.something-went-wrong')}
    icon={faTimesCircle}
    color={COLOR_ERROR}
    submitLabel={t('common.try-again')}
    onFormSubmit={onSubmit}
  />
)

export default memo(SomethingWentWrong)
